module.exports = __webpack_public_path__ + "img/no_pay_icons.34e34b18.png";